import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { generateRandomString } from '@app/shared/helpers/helpers';

@Component({
  selector: 'app-smash-iframe',
  templateUrl: './smash-iframe.component.html',
  styleUrls: ['./smash-iframe.component.scss'],
})
export class SmashIframeComponent implements OnInit {
  startAnimation = false;
  id: string;
  @Input() animationFadeInDelay?: number = 0;
  @Input() scriptUrl: string;
  @Output() ready: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    this.id = generateRandomString();
  }

  ngOnInit(): void {
  }

  onLoad() {
    setTimeout(() => this.startAnimation = true, this.animationFadeInDelay)
    this.ready.emit(true);
  }

}
